import React from 'react'
import T from 'prop-types'
import { Form, Field } from 'react-final-form'
import { injectIntl } from 'react-intl'
import Button from '@material-ui/core/Button'
import Input from 'components/common/Form/Input'
import getValidator, { VALIDATOR_EMAIL } from 'validation'
import messages from './translate'

function ForgotPassword({ intl: { formatMessage }, onSubmit }) {
  return (
    <Form
      validateOnBlur
      onSubmit={onSubmit}
      render={({
        handleSubmit,
        submitting,
        submitError,
        dirtySinceLastSubmit,
      }) => {
        const isShowSubmitError =
          Boolean(submitError) && !dirtySinceLastSubmit && !submitting

        return (
          <form onSubmit={handleSubmit}>
            {isShowSubmitError && (
              <div className="error static">{submitError}</div>
            )}
            <Field
              name="email"
              type="email"
              placeholder={formatMessage(messages.email)}
              className="form-control-lg"
              component={Input}
              disabled={submitting}
              validate={getValidator(VALIDATOR_EMAIL)}
            />
            <div className="form-group">
              <Button
                fullWidth
                href={null}
                type="submit"
                color="primary"
                size="large"
                variant="contained"
                className="login-form-submit-button"
                onClick={handleSubmit}
                disabled={submitting}>
                {formatMessage(messages.submit)}
              </Button>
            </div>
          </form>
        )
      }}
    />
  )
}

ForgotPassword.propTypes = {
  intl: T.shape({
    formatMessage: T.func,
  }).isRequired,
  onSubmit: T.func.isRequired,
}

export default injectIntl(ForgotPassword)
